// extracted by mini-css-extract-plugin
export var acceptButton = "_3q-5";
export var fullContent = "_3q-4";
export var link = "_3q-6";
export var linkIcon = "_3q-7";
export var sideContent = "_3q-3";
export var sideImage = "_3q-2";
export var sideImageWrapper = "_3q-1";
export var splitLayout = "_3q-0";